__turbopack_context__.v({
  "band": "PafBand-module__aIoUNW__band",
  "line": "PafBand-module__aIoUNW__line",
  "lines": "PafBand-module__aIoUNW__lines",
});
